import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import "./userGender.css";
import menPatient1 from "../assets/common/menPatient.png";
import womenPatient1 from "../assets/common/womanPatient.png";
import moment from "moment"; // Make sure to install moment.js
import { useMemo } from "react";

const PatientGenderChart = ({ genderData }) => {
  const femaleData = genderData?.find(item => item.name === "Female")?.y || 0;
  const maleData = genderData?.find(item => item.name === "Male")?.y || 0;
  const total = femaleData + maleData;
  
  const malePercentage = total ? (maleData / total) * 100 : 0;
  const femalePercentage = total ? (femaleData / total) * 100 : 0;

  const options = {
    chart: {
      type: "pie",
      height: 155,
      width: 155,
    },
    title: {
      text: null,
    },
    plotOptions: {
      pie: {
        innerSize: "0%",
        dataLabels: {
          enabled: false,
          format: "{point.name}: {point.percentage:.1f} %",
        },
      },
    },
    credits: {
      enabled: false,
    },
    series: [
      {
        name: "Patients",
        data: [
          { name: "Women Patients", y: femalePercentage, color: "#CE9DF4" },
          { name: "Men Patients", y: malePercentage, color: "#9DAEF4" },
        ],
      },
    ],
  };

  return (
    <div className="gender-chart-container ">
      <div className="charts-wrapper">
        <div
          className="chart mx-6 mt-4"
          style={{
            marginLeft: 10,
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <div>
            <HighchartsReact highcharts={Highcharts} options={options} />
            <p className="chart-label ml-9 mt-[-5px]">(Patients)</p>
          </div>
          <div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                marginTop: -30,
                marginRight: 20,
              }}
            >
              <img
                src={womenPatient1}
                style={{ height: 8, width: 8 }}
                alt="Female icon"
              />
              <p style={{ fontSize: 12, marginLeft: 3 }}>
                Female {femalePercentage.toFixed(1)}%
              </p>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                marginTop: 30,
              }}
            >
              <img
                src={menPatient1}
                style={{ height: 8, width: 8 }}
                alt="Male icon"
              />
              <p style={{ fontSize: 12, marginLeft: 3 }}>
                Male {malePercentage.toFixed(1)}%
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PatientGenderChart;
